module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy_NL.c739c7b3.pdf";